<template>
  <DefaultLayout>
    <slot name="background">
      <div class="col-md-12 pe-0">
        <div class="position-relative"
        style="height: 100vh; background-image: url(/img/unauthorized-zoom-background.svg); background-size: cover; background-repeat: no-repeat;">
        </div>
      </div>
    </slot>
    <div>
      <div class="container position-absolute zindex-5" style="width: 700px; left: 50%; top: 50%; transform: translate(-50%, -50%);">
        <div class="card p-4">
          <div style="display: flex; justify-content: space-between;">
            <h3>Network Meetings</h3>
          </div>
          <p>
            This is an invite only feature allowing you to easily create and facilitate meetings within your network. It provides easy management of:
          </p>
          <ul>
            <li>Recurring meetings with attendance management</li>
            <li>Bulk invites to all network participants</li>
            <li>And more!</li>
          </ul>
          <p>
            Meetings are currently limited to 45 minutes due to funding constraints. However, don't hesitate to inquire about sharing or funding your
            meeting with Resonance. We may accommodate your needs based on frequency and timeframe.
          </p>
          <p>Contact our team to learn more!</p>
          <button class="btn btn-primary" style="padding: 0.425rem 1.7rem; width: fit-content !important;" @click="contactNow">
            Schedule a call
          </button>
        </div>
      </div>
    </div>
  </DefaultLayout>
</template>
<script>
import DefaultLayout from '@/views/layouts/default';

export default {
  name: 'UnauthorizedZoom',
  components: {
    DefaultLayout,
  },
  methods: {
    contactNow() {
      if (window.umami && typeof window.umami.track === 'function') {
        window.umami.track('open-support-modal');
      }
      this.$bus.emit('show-support-form');
    },
  },
};
</script>
